import { useContext, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import StudentInfo from '../components/StudentInfo'
import AssemssmentsInfo from '../components/AssessmentInfo'
import { getStudentById } from '../libs/student-service'
import {
    Assessment,
    getAssessmentsByStudentId,
    updateAssessmentDetailScore,
} from '../libs/assessment-service'
import { Student as StudentModel } from '../libs/student-service'
import { UpdateModal } from '../components/assessment-info/UpdateModal'
import { ClassContext } from '../App'
import { Class } from '../libs/login-service'
import { Batch } from '../libs/batch-service'

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
    background-color: #ffffff;
    border-radius: 10px;
`
const Header = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    border-bottom: 1px solid #e5e6eb;
`
interface Prop {
    setTitle: React.Dispatch<React.SetStateAction<string>>
}
export default function Student({ setTitle }: Prop) {
    useEffect(() => {
        setTitle('Report')
    }, [])

    const classes = useContext(ClassContext)
    const [selectedClass, setSelectedClass] = useState<Class | undefined>(
        classes[0]
    )
    const [batch, setBatch] = useState<Batch | undefined>(
        classes[0]?.batches[0]
    )

    useEffect(() => {
        setSelectedClass(classes[0])
        setBatch(classes[0]?.batches[0])
    }, [classes])

    const handleBatchChange = (batchId: number) => {
        const newBatch = selectedClass?.batches.find((b) => b.id === batchId)
        if (newBatch) {
            setBatch(newBatch)
        }
    }

    const { id } = useParams()
    const [student, setStudent] = useState<StudentModel>()
    const [assessments, setAssessments] = useState<Assessment[]>([])
    const [showUpdate, setShowUpdate] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [score, setScore] = useState<number>(0)
    const [selectedAssessment, setSelectedAssessment] = useState<Assessment>()

    const fetchAssessments = async () => {
        if (!id) return
        const assessments = await getAssessmentsByStudentId(id)
        setAssessments(assessments)
    }

    useEffect(() => {
        if (!id) {
            return
        }

        const fetchStudent = async () => {
            const student = await getStudentById(id)

            setStudent(student)
        }

        fetchStudent()
        fetchAssessments()
    }, [])

    async function handleUpdateScore(
        message: string,
        score: number,
        selectedAssessment: Assessment
    ) {
        setShowUpdate(true)
        setMessage(message)
        setScore(score)
        setSelectedAssessment(selectedAssessment)
    }

    function handleUpdateCancel() {
        setShowUpdate(false)
    }

    async function handleUpdateConfirm(selectedAssessment: Assessment) {
        selectedAssessment.detailScore = selectedAssessment.detailScore.map(
            (s) => (s.label === message ? { ...s, score: score } : s)
        )

        await updateAssessmentDetailScore(selectedAssessment)
        setShowUpdate(false)
        await fetchAssessments()
    }

    const filteredAssessments = useMemo(
        () =>
            batch
                ? assessments.filter((a) => a.batch === batch.name)
                : assessments,
        [assessments, batch]
    )

    if (student) {
        return (
            <Wrapper>
                {showUpdate && selectedAssessment && (
                    <UpdateModal
                        message={message}
                        score={score}
                        handleCancel={() => handleUpdateCancel()}
                        handleConfirm={() =>
                            handleUpdateConfirm(selectedAssessment)
                        }
                        setScore={setScore}
                    />
                )}
                <Header>
                    Individual Analysis | Track student's performance in details
                    here
                </Header>
                <StudentInfo
                    student={student}
                    selectedClass={selectedClass}
                    batch={batch}
                    onBatchChange={handleBatchChange}
                />
                <AssemssmentsInfo
                    assessments={filteredAssessments}
                    handleUpdateScore={handleUpdateScore}
                />
            </Wrapper>
        )
    }

    return <>Loading Student info</>
}
